import { __decorate } from "tslib";
import { I18nThemed } from 'interfaces/mixins';
import { v } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/framework/core/mixins/Themed';
import css from '../css/document.m.css';
let PageNotFound = class PageNotFound extends I18nThemed {
    render() {
        const { title, text } = this.properties;
        return v('div', { classes: [this.theme(css.root)] }, [
            v('h1', { classes: [this.theme(css.heading)] }, [title]),
            v('article', { classes: [this.theme(css.article)], innerHTML: text.data })
        ]);
    }
};
PageNotFound = __decorate([
    theme(css)
], PageNotFound);
export { PageNotFound };
